import { render } from "./MbaDataScience.vue?vue&type=template&id=51862c32"
import script from "./MbaDataScience.vue?vue&type=script&lang=js"
export * from "./MbaDataScience.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__